export default __webpack_public_path__ + "static/media/sweet & spicy.3b834711.png";